






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CrmChatAttemics extends Vue {
  @Prop()
  redirectUrl!: string;

  chamarAttemics(): void {
    window.open(this.redirectUrl, '_blank');
  }
}
